module.exports = __webpack_public_path__ + "img/img-welcome@2x.d88436b3.png";